//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import BaseModal from "../../../global/components/Modals/BaseModal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SnapshotSection from "../commonComponents/SnapshotSection";
import CompanionSelection from "../commonComponents/CompanionSelection";
import CameraInfoForm from "../../../features/camerOnboarding/manualCameraOnboarding/components/CameraInfoForm";
import StreamInfoForm from "../../../features/camerOnboarding/manualCameraOnboarding/components/StreamInfoForm";
import {
  fetchAllDevices,
  fetchCompanionListByCameraSuccess,
  getFovIds,
  resetOnboardingCamera,
  setSelectedCameraQR,
  setUnpairedCamDetails,
  showNotificationBanner,
  updateDevices,
  addManualCameraRequest,
  modalOpen,
  setSelectedCameraName,
  fetchFloor,
  fetchSite,
  fetchArea,
  fetchSubArea,
  fetchCompanion,
  setCamDetails,
  setLoading,
  triggerUnpairedCamerasRefresh,
  setCamPosition,
  selectEncodes,
  setUserName,
  setPassword,
  setHostName,
  setPortName,
  refreshCameraPage,
  setManualApiResponse,
  disableNextButton,
  addRtspUrl,
  showCalibrationBanner,
} from "../../../store/actions";
import { useEffect, useState, useRef, useCallback } from "react";
import {
  findImageForList,
  getResourceIdentifierForDevice,
  isDuplicateCamName,
} from "../../../global/utility/Utils";
import LocationSelection from "../commonComponents/LocationSelection";
import NameInfoForm from "./components/NameInfoForm";
import {
  applyDevice,
  applyFieldofView,
  fetchCompanionListByCamera,
  pairCamera,
} from "../../../model/cameraonboardingService";
import {
  fetchAllCameraAndFovsForRbac,
  updateOnboardedDetails,
} from "../../../api/DeviceServiceManager";
import { LICENSE_SKU_PATTERNS, LICENSE_STATUS, getActiveLicenseSku } from "../../../global/constants/licensesConstants";
import { batchLicenseActions } from "../../../store/actions/license-actions";
import { Loader } from "@vds/loaders";
import { Icon } from "@vds/icons";
import StreamCalibrationModal from "./components/StreamCalibrationModal";
import { useHistoricalSearchEligibility } from "../hooks/useHistoricalSearchEligibility";
import "../../../styles/calibrationStyles.css";
import {encodeOrDecodeRtspCredentials} from "../../../global/utility/Utils";
import { DEVICE_CONSTANTS } from "../../../constants/DeviceConstants";
import { safeDecodeURIComponent } from "../../../global/utility/devicesUtils";

const HS_SKU = LICENSE_SKU_PATTERNS.FORENSIC_SEARCH_V2;

const DiscoverCamera = ({ onClose, selectedSiteId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const {
    companionDevice,
    selectedCamQR,
    cameraName,
    areaObject,
    floorObject,
    siteObject,
    subAreaObject,
    manualAddResponse,
    streamInfo,
    blurValue = "NA",
    rtspUrl,
    modalOpenObj,
    manualAddStatus,
    disableButton,
    userFullName,
    userPassword,
    userHostName,
    userPortName,
    manualApiResponse,
    manualStepTrigger,
    calculatedAvailabilityCount
  } = useSelector((state) => state.cameraOnboardingReducer);
  const fieldOfViews =
    useSelector((state) => state.cameraOnboardingReducer.fovIds) || [];
  const FOVIds = fieldOfViews?.map((item) => item.fovId);
  const { cameraList, fovList, companionDeviceList, discoveredCamerasList } =
    useSelector((state) => state?.deviceReducer);
  const { unpairedImages } = useSelector((state) => state.imagesReducer);
  const isHistoricalSearchEligible = useHistoricalSearchEligibility(companionDevice?.id ?? modalOpenObj?.camDetails?.parentdeviceid);
  const [isImageDownloadFailed, setIsImageDownloadFailed] = useState(false);// This state variable is unused. need to test when while removing.
  const camPositionRef = useRef({ top: 0, left: 0 });
  const [step, setStep] = useState(
    modalOpenObj?.onBoradType === "Manual" ? 0 : 1
  );
  const [camResourceIdf, setCamResourceIdf] = useState(null);
  const [companionData, setCompanionData] = useState([]);
  const [selectCameraQr, setSelectedCameraQr] = useState("");
  const [fovDatas, setFovDatas] = useState([]);
  const formRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showExampleModal, setShowExampleModal] = useState(false);
  const [handleNextCalibrationSteps, setHandleNextCalibrationSteps] = useState(false);
  const [showManualCalibration, setShowManualCalibration] = useState(false);
  const [manualCount, setmanualCount] = useState(0);
  const [manualDevices, setManualDevices] = useState([]);
  const [showManualBack, setShowManualBack] = useState(false);
  const [showCalibrationLoader, setShowCalibrationLoader] = useState(false);
  const [originalValues, setOriginalValues] = useState([]);
  const [fovIdsCount, setFovIdsCount] = useState(0);
  useEffect(() => {
    fetchIdentifiers(cameraList, fovList);
  }, [cameraList && fovList && selectedCamQR]);
  useEffect(() => {
    setStep(modalOpenObj?.onBoradType === "Manual" ? 0 : 1);
  }, [modalOpenObj?.onBoradType]);
  const tagIds = [];
  const isValidData = (data) => data && data !== "NA";
  isValidData(siteObject?.id) && tagIds.push(siteObject?.id);
  isValidData(floorObject?.id) && tagIds.push(floorObject?.id);
  isValidData(areaObject?.id) && tagIds.push(areaObject?.id);
  //need to change in edit flow
  const fetchIdentifiers = (cameraList, fovList) => {
    let fovIdentifiers = [];
    const camDeviceInfo = cameraList?.find(
      (camera) => camera?.qrcode === selectedCamQR
    );
    const fovItems =
      fovList?.filter((item) => item?.parentdeviceid === selectedCamQR) || [];
    if (camDeviceInfo) {
      const camResourceIdentifier =
        getResourceIdentifierForDevice(camDeviceInfo);
      setCamResourceIdf(camResourceIdentifier);
    } else if (!modalOpenObj?.editFlow) {
      setCamResourceIdf({ qrcode: selectedCamQR });
    }

    FOVIds?.forEach((fovId) => {
      if (modalOpenObj?.editFlow == true) {
        fovIdentifiers?.push({ deviceid: fovId });
      } else {
        const foundDevice = fovList?.find((device) => device?.id === fovId);
        if (foundDevice) {
          const fovResourceIdentifier =
            getResourceIdentifierForDevice(foundDevice);
          fovIdentifiers.push(fovResourceIdentifier);
        }
      }
    });

    fovItems?.forEach((stream) => {
      const foundDevice = fovList?.find((device) => device?.id === stream?.id);
      if (foundDevice) {
        const fovResourceIdentifier =
          getResourceIdentifierForDevice(foundDevice);
        fovIdentifiers.push(fovResourceIdentifier);
      }
    });
  };
  useEffect(() => {
    if (
      modalOpenObj?.onBoradType === "Manual" &&
      ((manualAddResponse && manualAddResponse.length > 0) ||
        manualAddStatus === "SUCCESS")
    ) {
      setIsLoading(false);
      setStep(1);
    }
  }, [manualAddResponse, manualAddStatus, manualStepTrigger]);

  useEffect(() => {
    if (
      modalOpenObj?.onBoradType === "Manual" &&
      ((manualAddResponse && manualAddResponse.length > 0) ||
        manualAddStatus === "SUCCESS")
    ) {
      const responseToMerge =
        manualAddResponse && manualAddResponse.length > 0
          ? manualAddResponse
          : manualApiResponse;
      dispatch(setSelectedCameraQR(responseToMerge[0]?.qrcode));
      setSelectedCameraQr(responseToMerge[0]?.qrcode);
      const fovIds = responseToMerge[0]?.fovs?.map((item, index) => ({
        fovId: item.fovID,
        fovName: streamInfo[index]?.name,
      }));
      let mergedResponse;
      if (responseToMerge && responseToMerge?.length > 0) {
        mergedResponse = responseToMerge?.map((camera) => ({
          qrcode: camera?.qrcode,
          fovs: camera?.fovs?.map((fov, index) => ({
            fovID: fov?.fovID,
            source: fov?.source,
            encoders: fov?.encoders?.map((encoder) => ({
              encoding: streamInfo[index]?.encoding || encoder.encoding,
              resolution: streamInfo[index]?.resolution || encoder.resolution,
              url: streamInfo[index]?.url || encoder.url,
            })),
          })),
        }));
        dispatch(setManualApiResponse(mergedResponse));
      }

      dispatch(getFovIds(fovIds));
      setFovDatas(fovIds);
      setCompanionData(companionDevice);
      setIsLoading(false);
    }
  }, [manualAddResponse, modalOpenObj?.onBoradType, streamInfo]);

  useEffect(() => {
    if (manualAddStatus === "FAILURE") {
      dispatch(modalOpen({}));
      dispatch(resetOnboardingCamera());
      const notificationInfo = {
        type: "Camera pairing",
        priority: "critical",
        data: {
          subTitle:
            "Add Manual Camera API is getting faild, Please try again later.",
        },
        showNotification: true,
      };
      if (modalOpenObj?.onBoradType == "Manual") {
        setStep(0);
      }
      dispatch(showNotificationBanner(notificationInfo));
    }
  }, [manualAddStatus]);
  const getLicenseActionItems = () => {
    if (!isHistoricalSearchEligible) return [];
    if (modalOpenObj?.onBoradType === "Manual") {
      return streamInfo?.map((s) => ({ fovId: s.fovId, enableSearch: !!s.enableSearch })) || [];
    }
    return fieldOfViews?.map((f) => ({ fovId: f.fovId, enableSearch: !!f.enableSearch })) || [];
  };

  const buildLicenseActions = (isEditFlow) => {
    const items = getLicenseActionItems();
    return items
      .map(({ fovId, enableSearch }) => {
        if (!fovId) return null;
        if (isEditFlow) {
          const originalFov = fovList?.find((f) => f.id === fovId);
          const hsInfo = originalFov?.licensesinfo?.find((l) => l.sku === HS_SKU);
          const hsStatus = hsInfo?.status?.toLowerCase();
          if (enableSearch) {
            if (hsStatus === LICENSE_STATUS.ACTIVE) return null;
            if (hsStatus === LICENSE_STATUS.SUSPENDED) return { fovId, action: "resume" };
            const currentSku = getActiveLicenseSku(originalFov?.licenses || []);
            if (currentSku && currentSku !== HS_SKU) {
              const currentLicenseInfo = originalFov?.licensesinfo?.find((l) => l.sku === currentSku);
              if (currentLicenseInfo?.status?.toLowerCase() === LICENSE_STATUS.ACTIVE) {
                return { fovId, action: "switch", currentSku };
              }
            }
            return { fovId, action: "assign" };
          } else {
            if (hsStatus === LICENSE_STATUS.ACTIVE) return { fovId, action: "remove" };
            return null;
          }
        }
        return enableSearch ? { fovId, action: "assign" } : null;
      })
      .filter(Boolean);
  };

  // Delegates to batchLicenseActionsSaga which runs API calls in parallel,
  // patches deviceReducer.fovList, and refreshes licenseReducer.licenses —
  // matching exactly what changeLicenseTypeSaga does from the Settings page.
  const executeLicenseActions = (actions) =>
    new Promise((resolve) => {
      dispatch(batchLicenseActions({ actions, accountId: activeSession?.accountId, resolve, suppressBanners: true }));
    });

  // Called by StreamCalibrationModal on calibration success with a map of { [fovId]: boolean }.
  // On skip, called with null — no license assignment.
  // Returns { anyFailed } so the caller can show the appropriate banner.
  const handleCalibrationComplete = async (enableSearchMap) => {
    dispatch(refreshCameraPage(true));
    navigate("/devices", { state: { tabName: "Camera" } });
    let anyFailed = false;
    if (enableSearchMap && isHistoricalSearchEligible) {
      const licenseActions = Object.entries(enableSearchMap)
        .filter(([, enabled]) => enabled)
        .map(([fovId]) => ({ fovId, action: "assign" }));
      if (licenseActions.length > 0) {
        const result = await executeLicenseActions(licenseActions);
        anyFailed = result?.anyFailed ?? false;
      }
    }
    return { anyFailed };
  };

  const handleSkipCalibration = async () => {
    await handleCalibrationComplete(null);
    handleClose(true);
  };

  const handleSave = async (fovList) => {
    try {
      // call apply device api
      setLoading(true);
      const resp = await applyDevice(
        camResourceIdf,
        cameraName,
        activeSession,
        siteObject?.name,
        siteObject?.id,
        floorObject?.name,
        floorObject?.id,
        areaObject?.name,
        areaObject?.id,
        subAreaObject?.name,
        subAreaObject?.id,
        blurValue,
        camPositionRef.current
      );

      if (resp) {
        if (resp?.error) {
          setLoading(false);
          if (modalOpenObj?.onBoradType === "Manual") {
            setStep(0);
          } else {
            setStep(1);
          }
          throw new Error(resp?.message);
        } else {
          const camId = resp?.id;
          // call apply FOV api
          const applyFovResp = await Promise.all(
            fieldOfViews?.map(async (refFov) => {
              const foundDevice = fovList?.find(
                (device) => device?.id === refFov?.fovId
              );
              setLoading(true);
              const resp = await applyFieldofView(
                getResourceIdentifierForDevice(foundDevice),
                refFov?.fovName,
                activeSession
              );
              if (resp && resp != "" && !resp.error) {
                setLoading(false);
                return resp;
              } else {
                setLoading(false);
                return;
              }
            })
          );

          if (applyFovResp && applyFovResp != "") {
            setLoading(false);
            return true;
          } else if (
            applyFovResp &&
            applyFovResp.some((i) => i !== undefined)
          ) {
            setLoading(false);
            return camId;
          } else {
            setLoading(false);
            return;
          }
        }
      }
    } catch (error) {
      setLoading(false);
      console.log("API Save Error");
      return false;
    }
  };
  // call the pairing api for unpaired cam
  const pairApi = async (compTagIdsList) => {
    try {
      const pairResponse = await pairCamera(
        companionDevice?.qrcode,
        selectedCamQR,
        activeSession,
        compTagIdsList
      );
      if (pairResponse) {
        if (
          pairResponse?.error &&
          pairResponse?.message !== "Pairing requested."
        ) {
          dispatch(resetOnboardingCamera());
          const notificationInfo = {
            type: "Camera pairing",
            priority: "critical",
            data: {
              subTitle: "Something went wrong, Please try again later.",
            },
            showNotification: true,
          };
          if (modalOpenObj?.onBoradType === "Manual") {
            setStep(0);
          } else {
            setStep(1);
          }
          dispatch(showNotificationBanner(notificationInfo));
          navigate("/devices");
          onClose();
          dispatch(resetOnboardingCamera());
          throw new Error(pairResponse?.message);
        } else if (
          pairResponse?.status !== 200 &&
          pairResponse?.status !== 204 &&
          pairResponse?.message !== "Pairing requested."
        ) {
          const notificationInfo = {
            type: "Camera pairing",
            priority: "critical",
            data: {
              subTitle: "Something went wrong, Please try again later.",
            },
            showNotification: true,
          };
          if (modalOpenObj?.onBoradType === "Manual") {
            setStep(0);
          } else {
            setStep(1);
          }
          onClose();
          dispatch(resetOnboardingCamera());
          dispatch(showNotificationBanner(notificationInfo));
        } else {
          dispatch(triggerUnpairedCamerasRefresh());
          dispatch(fetchAllDevices());
          fetchIdentifiers(cameraList, fovList);
          const notificationInfo = {
            type: "Camera pairing",
            priority: "success",
            data: {
              subTitle: "Camera has been paired successfully.",
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
          return true;
        }
      } else {
        const notificationInfo = {
          type: "Camera pairing",
          priority: "critical",
          data: {
            subTitle: "Something went wrong, Please try again later.",
          },
          showNotification: true,
        };
        dispatch(showNotificationBanner(notificationInfo));
        dispatch(resetOnboardingCamera());
        if (modalOpenObj?.onBoradType === "Manual") {
          setStep(0);
        } else {
          setStep(1);
        }
        return false;
      }
    } catch (error) {
      console.log("Pair API Error");
      const notificationInfo = {
        type: "Camera pairing",
        priority: "critical",
        data: {
          subTitle: "Something went wrong, Please try again later.",
        },
        showNotification: true,
      };
      if (modalOpenObj?.onBoradType === "Manual") {
        setStep(0);
      } else {
        setStep(1);
      }
      onClose();
      dispatch(resetOnboardingCamera());
      dispatch(showNotificationBanner(notificationInfo));
      return false;
    }
  };
  const handlePostPairApiCalls = () => {
    try {
      fetchAllCameraAndFovsForRbac(activeSession)?.then(
        (cameraAndFovDevices) => {
          dispatch(
            updateDevices({
              cameraList: cameraAndFovDevices?.cameras,
              fovList: cameraAndFovDevices?.fovs,
            })
          );
          handleSave(cameraAndFovDevices?.fovs).then((resp) => {
            if (resp) {
              const notificationInfoForCalibration = {
                type: "Calibration after camera onboarding",
                priority: "success",
                data: {
                  title:
                    "Your camera has been successfully onboarded. Now it needs calibration",
                  subTitle: "Follow the steps below to calibrate your camera.",
                },
                showNotification: true,
              };
              dispatch(showCalibrationBanner(notificationInfoForCalibration));
              setIsLoading(false);
              setCameraOnboarded(true);
              setStep(3);
              setIsNextDisabled(false);
              dispatch(disableNextButton(false));
              setShowCalibrationLoader(false);
            } else {
              if (modalOpenObj?.onBoradType === "Manual") {
                setStep(0);
                setShowCalibrationLoader(false);
              } else {
                setStep(1);
                setShowCalibrationLoader(false);
              }
            }
          });
        }
      );
    } catch (error) {
      console.error("Error:", error);
      setShowCalibrationLoader(false);
    }
  };

  const doAction = () => {
    setIsLoading(true);
    if (!modalOpenObj?.editFlow) {
      setIsLoading(true);
      pairApi(tagIds)?.then((resp) => {
        if (resp) {
          setShowCalibrationLoader(true);
          handlePostPairApiCalls();
        }
      });
    } else {
      handleSave(fovList)?.then((resp) => {
        setIsLoading(true);
        if (resp) {
          setIsLoading(false);
          onClose();
          dispatch(resetOnboardingCamera());
        }
      });
    }
  };

  // initialize camera info to redux store
  useEffect(() => {
    const selCamQR = modalOpenObj?.editFlow
      ? modalOpenObj?.camDetails?.qrcode
      : selectedCamQR;
    const selCamName = modalOpenObj?.camDetails?.name;
    const selsiteName =
      modalOpenObj?.camDetails?.customdata?.location?.site?.name;
    const selsiteId = modalOpenObj?.camDetails?.customdata?.location?.site?.tag;
    const selFloorId =
      modalOpenObj?.camDetails?.customdata?.location?.floor?.tag;
    const selFloorName =
      modalOpenObj?.camDetails?.customdata?.location?.floor?.name;
    const selAreaId = modalOpenObj?.camDetails?.customdata?.location?.area?.tag;
    const selSubAreaId =
      modalOpenObj?.camDetails?.customdata?.location?.subarea?.tag;
    const selAreaName =
      modalOpenObj?.camDetails?.customdata?.location?.area?.name;
    const selSubAreaName =
      modalOpenObj?.camDetails?.customdata?.location?.subarea?.name;
    const pairingFlow = modalOpenObj?.isPairing;
    const selectedItem = discoveredCamerasList?.find((item) => {
      return modalOpenObj?.isPairing
        ? item?.qrcode === selCamQR && item?.resourceidentifier?.qrcode === modalOpenObj?.compName?.qrcode
        : modalOpenObj?.camDetails?.qrcode === item?.qrcode &&
            modalOpenObj?.camDetails?.parentdeviceid === item?.discoveredby;
    });
    // camDetails.parentdeviceid doesn't exist in the pairing flow (modalOpen is
    // dispatched without camDetails) — fall back to the discovered camera's own
    // discoveredby, which holds the companion id in that flow.
    const parentdeviceid = pairingFlow
      ? selectedItem?.discoveredby
      : modalOpenObj?.camDetails?.parentdeviceid;
    const selCompanion = companionDeviceList?.find(
      (item) => item.id === parentdeviceid
    );
    const selectedItemFovIds = [],
      selectedItemFovImages = [],
      selectedItemFovNames = [];

    selectedItem?.fovs?.forEach((itemFov) => {
      selectedItemFovIds.push(itemFov.fovID);
      selectedItemFovImages.push(
        findImageForList(unpairedImages, itemFov.fovID)
      );
      selectedItemFovNames.push({
        fovName: itemFov.fovName,
        fovId: itemFov.fovID,
      });
      selectedItemFovImages.push("");
    });

    const fovItems =
      fovList?.filter(
        (item) => item.parentdeviceid === modalOpenObj?.camDetails?.id
      ) || [];

    const defaultFOVNames = pairingFlow
      ? selectedItemFovNames
      : fovItems?.map((item) => {
          const fovData = fovList?.find((f) => f.id === item.id);
          const hsInfo = fovData?.licensesinfo?.find((l) => l.sku === HS_SKU);
          return {
            fovName: item.name,
            fovId: item.id,
            enableSearch: hsInfo?.status?.toLowerCase() === LICENSE_STATUS.ACTIVE,
          };
        });

    let companionList = [];
    if (selCompanion && selCompanion?.id) {
      companionList?.push({ id: selCompanion?.id, name: selCompanion?.name });
      dispatch(fetchCompanionListByCameraSuccess(companionList));
    } else {
      if (selCamQR) {
        setIsLoading(true);
        fetchCompanionListByCamera(activeSession, selCamQR)
          ?.then((response) => {
            const companionDeviceListBySelectedSite = response?.filter((item) => item?.siteids?.find((siteId) => siteId === selectedSiteId));
            companionDeviceListBySelectedSite?.forEach((item) => {
              companionList?.push({ id: item.id, name: item.name });
            });
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            dispatch(fetchCompanionListByCameraSuccess(companionList));
            setIsLoading(false);
          });
      }
    }
    if (!modalOpenObj?.editFlow)
      dispatch(setUnpairedCamDetails({ qrcode: selCamQR }));
    dispatch(setSelectedCameraQR(selCamQR));
    dispatch(setSelectedCameraName(selCamName));
    dispatch(fetchSite({ name: selsiteName, id: selsiteId }));
    dispatch(fetchFloor({ name: selFloorName, id: selFloorId }));
    dispatch(fetchArea({ name: selAreaName, id: selAreaId }));
    dispatch(fetchSubArea({ name: selSubAreaName, id: selSubAreaId }));
    // Skip dispatch when lookup comes up empty (e.g. this effect re-firing after
    // pair success refreshes discoveredCamerasList and modalOpenObj.compName no
    // longer matches) — an empty dispatch would overwrite the correct companionDevice
    // already in redux (set by this effect's first run or CompanionSelection) with undefined.
    if (selCompanion?.id) {
      dispatch(
        fetchCompanion({
          id: selCompanion?.id,
          name: selCompanion?.name,
          qrcode: selCompanion?.qrcode,
        })
      );
    }
    dispatch(setCamDetails(modalOpenObj?.camDetails));
    if (defaultFOVNames && defaultFOVNames.length > 0) {
      dispatch(getFovIds(defaultFOVNames));
      setFovDatas(defaultFOVNames);
    }
  }, [
    dispatch,
    companionDeviceList,
    fovList,
    cameraList,
    modalOpenObj,
    modalOpenObj?.editFlow,
  ]);

  useEffect(() => {
    if (
      modalOpenObj &&
      modalOpenObj?.editFlow &&
      modalOpenObj?.onBoradType === "Manual" &&
      modalOpenObj?.camDetails?.fovs
    ) {
      const manualFovObject = [];

      modalOpenObj?.camDetails?.fovs?.forEach((fov, fovIndex) => {
        const fovData = fovList?.find((f) => f.id === fov?.id);
        const hsInfo = fovData?.licensesinfo?.find((l) => l.sku === HS_SKU);
        const enableSearch = hsInfo?.status?.toLowerCase() === LICENSE_STATUS.ACTIVE;
        fov?.customdata?.encoders?.forEach((encoder, encoderIndex) => {
          const objectToPush = {
            url: encoder?.url,
            urlRtsp: decodeURIComponent(encoder?.url),
            fovName: fov?.name,
            fovId: fov?.id,
            resolution: encoder?.resolution,
            encoding: encoder?.encoding,
            fovIndex: fovIndex,
            encoderIndex: encoderIndex,
            rtspPath: extractPathFromUrl(encoder?.url),
            enableSearch,
          };
          manualFovObject.push(objectToPush);
        });
      });

      if (manualFovObject && manualFovObject?.length > 0) {
        const originalValuesArray = manualFovObject
          .map((fovObj) => {
            const url = fovObj?.url;
            const encoding = fovObj?.encoding;
            const resolution = fovObj?.resolution;
            const parts = url?.split("rtsp://");
            const decodeUrl = encodeOrDecodeRtspCredentials(url);

            if (parts && parts.length > 1) {
              const credentials = parts[1].split("@")[0];
              const username = parts[1].split(":")[0]
              const afterColon = parts[1].split(":")[1];
              const  password = afterColon.split("@")[0];
              const modifiedPassword = password;
               const afterAt = afterColon.split("@")[1];
              const hostPortPath = afterAt.split("/")[0];
              const [host, port] = hostPortPath.includes(":") ? hostPortPath.split(":") : [hostPortPath, ""];
              const pPort = parts[1].split(":").length > 2  ? parts[1].split(":")[2].split("/")[0] : port;

              return {
                userFullName: username || "",
                userPassword: modifiedPassword || "",
                userHostName: host || "",
                userPortName: pPort || "",
                rtspUrl: decodeUrl || "",
                encoding: encoding || "",
                resolution: resolution || "",
                fovId: fovObj?.fovId,
                fovName: fovObj?.fovName,
                rtspPath: fovObj?.rtspPath || "",
              };
            }
            return null;
          })
          .filter(Boolean);
        setOriginalValues(originalValuesArray);

        if (originalValuesArray?.length > 0) {
          const firstFov = originalValuesArray[0];
          dispatch(setUserName(safeDecodeURIComponent(firstFov?.userFullName)));
          dispatch(setPassword(safeDecodeURIComponent(firstFov?.userPassword)));
          dispatch(setHostName(firstFov?.userHostName));
          dispatch(setPortName(firstFov?.userPortName));
          dispatch(addRtspUrl(firstFov?.rtspUrl));
        }
        dispatch(selectEncodes(manualFovObject));
      }
    }
  }, [
    modalOpenObj?.camDetails?.fovs,
    modalOpenObj?.editFlow,
    modalOpenObj?.onBoradType,
    dispatch,
  ]);

  const [cameraOnboarded, setCameraOnboarded] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const handleNextDisableChange = useCallback((disabled) => {
    setIsNextDisabled(disabled);
  }, []);
  const handleImageDownloadFailure = (failed) => {
    setIsImageDownloadFailed(failed);
  };

  const hasValuesChanged = () => {
    if (!Array.isArray(originalValues) || originalValues.length === 0) {
      return false;
    }

    return originalValues?.some((originalFov) => {
      const currentStreamInfo = streamInfo?.find(
        (stream) =>
          stream?.fovId === originalFov?.fovId ||
          stream?.fovName === originalFov?.fovName
      );

      if (!currentStreamInfo) return false;

      const currentEncoding = currentStreamInfo?.encoding || "";
      const currentResolution = currentStreamInfo?.resolution || "";
      const currentUrl = currentStreamInfo?.urlRtsp || "";

      return (
        userFullName !== originalFov?.userFullName ||
        userPassword !== originalFov?.userPassword ||
        userHostName !== originalFov?.userHostName ||
        userPortName !== originalFov?.userPortName ||
        currentUrl !== originalFov?.rtspUrl ||
        currentEncoding !== originalFov?.encoding ||
        currentResolution !== originalFov?.resolution
      );
    });
  };

  const handleClose = useCallback((skipRefresh) => {
    if (cameraOnboarded && !skipRefresh) dispatch(refreshCameraPage(true));
    dispatch(resetOnboardingCamera());
    if (onClose) onClose();
    if (modalOpenObj?.onBoradType === "Manual") {
      setStep(0);
    } else {
      setStep(1);
    }
  }, [dispatch, modalOpenObj?.onBoradType, onClose, cameraOnboarded]);

  const handleBack = () => {
    if (
      step === 1 &&
      modalOpenObj?.onBoradType === "Manual" &&
      modalOpenObj?.editFlow
    ) {
      setStep(0);
    } else if (step === 1 && modalOpenObj?.onBoradType === "Manual") {
      setStep(0);
    } else if (
      (step === 1 && modalOpenObj?.onBoradType === "Auto") ||
      (step === 0 && modalOpenObj?.onBoradType === "Manual")
    ) {
      onClose();
    } else {
      setStep(1);
    }
  };
const extractPathFromUrl = useCallback((url) => {
    if (!url) return "/";
    const parts = url.split("://");
    if (parts?.length < 2) return "/";
    const urlParts = parts[1].split("/");
    if (urlParts?.length < 2) return "/";
    return "/" + urlParts?.slice(1)?.join("/");
  }, []);
  const handleManualFieldChange = async () => {
    if (
      userFullName &&
      userPassword &&
      companionDevice?.qrcode &&
      (selectedCamQR || selectCameraQr) &&
      streamInfo &&
      streamInfo.length > 0
    ) {
      try {
        setIsLoading(true);
        const payload = {
          userName: userFullName,
          pass: userPassword,
          companionQrcode: companionDevice?.qrcode,
          cameraDetailsId: selectedCamQR ? selectedCamQR : selectCameraQr,
          fovData: streamInfo,
        };
        const response = await updateOnboardedDetails(
          payload,
          activeSession,
          true
        );
        return response;
      } catch (error) {
        const notificationInfo = {
          type: "Updated camera fail",
          priority: "critical",
          showNotification: true,
        };
        dispatch(showNotificationBanner(notificationInfo));
        console.log("Error updating camera details:", error);
      } finally {
        setIsLoading(false);
        setStep(1);
      }
    }
  };

  const srollchange = useCallback(() => {
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  }, []);

  useEffect(() => {
    if (step == 1 && modalOpenObj?.onBoradType == "Auto") {
      if (!companionDevice?.id || !floorObject?.id || !areaObject?.id) {
        setIsNextDisabled(true);
      } else {
        setIsNextDisabled(false);
      }

      if (companionDevice?.id) {
        setFovDatas(fieldOfViews);
      }
    } else if (step == 2 && modalOpenObj?.onBoradType == "Auto") {
      const isDuplicateCam = modalOpenObj?.editFlow ? false : isDuplicateCamName(
        cameraList,
        selectedCamQR,
        cameraName
      );
      const isFov = !fieldOfViews || fieldOfViews?.length === 0 || fieldOfViews?.some(
        (item) => !item?.fovName?.trim()
      );
      if (!cameraName || isDuplicateCam || isFov) {
        setIsNextDisabled(true);
      } else {
        setIsNextDisabled(false);
      }
    } else if (modalOpenObj?.onBoradType == "Manual") {
      const isInvalidFields =
        !cameraName ||
        disableButton ||
        !companionDevice?.id ||
        !userFullName ||
        !userPassword;

      const isStreamsInvalid =
        !streamInfo ||
        streamInfo.length === 0 ||
        streamInfo.some((item) => {
          // Use 'name' if edited/touched, otherwise fall back to 'fovName'
          const activeName = item.name !== undefined ? item.name : item.fovName;

          return (
            !activeName ||
            !item.urlRtsp ||
            !item.encoding ||
            !item.resolution
          );
        });

      setIsNextDisabled(isInvalidFields || isStreamsInvalid);
    }
  }, [
    companionDevice,
    floorObject,
    areaObject,
    cameraName,
    selectCameraQr,
    step,
    streamInfo,
    fieldOfViews,
    userFullName,
    userPassword,
    modalOpenObj,
    disableButton
  ]);

  const handleOnBack = () => {
    if (showExampleModal) {
      setShowExampleModal(false);
    }
  };

  const handleManualBack = () => {
    setShowManualBack(true);
  };

  useEffect(() => {
    if (showManualCalibration) {
      setShowManualCalibration(showManualCalibration);
    } else {
      setShowManualCalibration(false);
    }
  }, [showManualCalibration, setShowManualCalibration]);

  const getWidthPercentage = () => {
    return window.innerWidth * 0.8;
  };
  const handlePrimaryButtonClick = () => {
    const { onBoradType, editFlow, isPairing } = modalOpenObj || {};

    // Step 0 handling (Manual flows only)
    if (step === 0) {
      if (onBoradType === "Manual" && editFlow) {
        if (hasValuesChanged()) {
          handleManualFieldChange();
        } else {
          setStep(1);
        }
      } else if (onBoradType === "Manual" && isPairing) {
        setIsLoading(true);
        dispatch(addManualCameraRequest());
      }
      return;
    }

    // Step 1 handling
    if (step === 1) {
      const finalPosition = camPositionRef.current;
      const action = editFlow ? setCamPosition : setUnpairedCamDetails;
      dispatch(action({ position: finalPosition }));
      if (onBoradType === "Manual" && editFlow) {
        handleManualEditSubmit();
      } else if (onBoradType === "Manual" && !editFlow) {
        handleManualCreateSubmit();
      } else if (onBoradType !== "Manual" && !editFlow) {
        setStep(2);
      } else if (onBoradType !== "Manual" && editFlow) {
        setStep(2);
      }
      return;
    }

    // Step 2 handling (Auto Create flow only)
    if (step === 2) {
      if (onBoradType !== "Manual" && editFlow) {
        handleAutoEditSubmit();
        return;
      } else if (onBoradType !== "Manual" && !editFlow) {
        handleAutoCreateSubmit();
        return;
      }
    }

    // Step 3 handling (Calibration)
    if (step === 3) {
      setHandleNextCalibrationSteps(true);
      return;
    }
  };

  const handleManualEditSubmit = async () => {
    setIsLoading(true);
    dispatch(disableNextButton(true));
    try {
      const licenseActions = buildLicenseActions(true);
      const resp = await handleSave(fovList);
      if (resp) {
        dispatch(showCalibrationBanner({ showNotification: false }));
        const notificationInfo = {
          type: "Updated Camera",
          priority: "success",
          data: {
            title: "Camera details updated successfully",
          },
          showNotification: true,
        };
        if (licenseActions.length === 0) {
          onClose();
          dispatch(resetOnboardingCamera());
          dispatch(showNotificationBanner(notificationInfo));
        } else {
          const licenseResult = await executeLicenseActions(licenseActions);
          onClose();
          dispatch(resetOnboardingCamera());
          if (licenseResult?.anyFailed) {
            const isDisableFlow = licenseActions.every((a) => a.action === "remove");
            dispatch(showNotificationBanner({
              type: "Failed to Calibrate",
              priority: "warning",
              data: {
                title: isDisableFlow
                  ? "Camera updated but couldn't disable search"
                  : "Camera updated but couldn't enable search",
                subTitle: isDisableFlow
                  ? "Search could not be disabled for the selected streams. Please try again from camera settings."
                  : "Search could not be enabled for the selected streams. Please try again from camera settings."
              },
              showNotification: true
            }));
          } else {
            dispatch(showNotificationBanner(notificationInfo));
          }
        }
        dispatch(refreshCameraPage(true));
      } else {
        dispatch(showNotificationBanner({
          type: "Updated Camera",
          priority: "critical",
          data: { title: "Failed to update camera details" },
          showNotification: true
        }));
      }
    } catch (error) {
      console.error("Manual Edit: Save error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleManualCreateSubmit = async () => {
    setIsLoading(true);
    dispatch(disableNextButton(true));
    try {
      const pairResp = await pairApi(tagIds);
      if (pairResp) {
        setShowCalibrationLoader(true);
        handlePostPairApiCalls();
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleAutoEditSubmit = () => {
    executeAutoEditSave();
  };

  const executeAutoEditSave = async () => {
    setIsLoading(true);
    dispatch(disableNextButton(true));
    try {
      const licenseActions = buildLicenseActions(true);
      const resp = await handleSave(fovList);
      if (resp) {
        dispatch(showCalibrationBanner({ showNotification: false }));
        const notificationInfo = {
          type: "Updated Camera",
          priority: "success",
          data: {
            title: "Camera details updated successfully",
          },
          showNotification: true,
        };
        if (licenseActions.length === 0) {
          onClose();
          dispatch(resetOnboardingCamera());
          dispatch(showNotificationBanner(notificationInfo));
        } else {
          const licenseResult = await executeLicenseActions(licenseActions);
          onClose();
          dispatch(resetOnboardingCamera());
          if (licenseResult?.anyFailed) {
            const isDisableFlow = licenseActions.every((a) => a.action === "remove");
            dispatch(showNotificationBanner({
              type: "Failed to Calibrate",
              priority: "warning",
              data: {
                title: isDisableFlow
                  ? "Camera updated but couldn't disable search"
                  : "Camera updated but couldn't enable search",
                subTitle: isDisableFlow
                  ? "Search could not be disabled for the selected streams. Please try again from camera settings."
                  : "Search could not be enabled for the selected streams. Please try again from camera settings."
              },
              showNotification: true
            }));
          } else {
            dispatch(showNotificationBanner(notificationInfo));
          }
        }
        dispatch(refreshCameraPage(true));
        fetchAllCameraAndFovsForRbac(activeSession)?.then(
          (cameraAndFovDevices) => {
            dispatch(
              updateDevices({
                cameraList: cameraAndFovDevices?.cameras,
                fovList: cameraAndFovDevices?.fovs,
              })
            );
          }
        );
      } else {
        dispatch(showNotificationBanner({
          type: "Updated Camera",
          priority: "critical",
          data: { title: "Failed to update camera details" },
          showNotification: true
        }));
      }
    } catch (error) {
      console.error("Auto Edit: Save error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAutoCreateSubmit = async () => {
    setIsLoading(true);
    dispatch(disableNextButton(true));
    try {
      const pairResp = await pairApi(tagIds);
      if (pairResp) {
        setShowCalibrationLoader(true);
        handlePostPairApiCalls();
      }
    } catch (error) {
      console.error("Auto Create: Pair error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getPrimaryButtonText = () => {
    const { onBoradType, editFlow } = modalOpenObj || {};

    if (step === 0 && onBoradType === "Manual") return "Next";
    if (step === 1 && onBoradType !== "Manual") return "Next";
    if (step === 1 && onBoradType === "Manual") return "Submit";
    if (step === 2) return "Submit";
    if (step === 3) return "Submit";
    if (manualCount < manualDevices?.length) return "Next";

    return "Submit";
  };
  const closeButtonText = () => {
    const { onBoradType, editFlow } = modalOpenObj || {};

    if (step === 0 && onBoradType === "Manual") return "Cancel";
    if (step === 1 && onBoradType !== "Manual") return "Cancel";
    if (step === 3) return "Skip";
    return "Back";
  };
  return (
    <>
      <BaseModal
        opened={Object.keys(modalOpenObj || {}).length ? true : false}
        title={
          step !== 3
            ? modalOpenObj?.onBoradType == "Manual" && modalOpenObj?.isPairing
              ? "Manually add camera"
              : modalOpenObj?.onBoradType == "Manual" && modalOpenObj?.editFlow
              ? "Edit manually added camera"
              : modalOpenObj?.onBoradType !== "Manual" && modalOpenObj?.editFlow
              ? "Edit camera"
              : "Add discovered Camera"
            : showExampleModal
            ? "Automatic calibration guidelines"
            : !showManualCalibration ? "Calibrate Streams" : ""
        }
        closeButtonText={closeButtonText()}
        primaryButtonText={getPrimaryButtonText()}
        onBack={
          step == 2 || step == 1
            ? handleBack
            : step === 3
            ? handleSkipCalibration
            : handleClose
        }
        onClose={handleClose}
        onCloseButtonClick={handlePrimaryButtonClick}
        disabled={
          step === 3
            ? isLoading
            : isNextDisabled ||
              disableButton ||
              (!modalOpenObj?.editFlow && calculatedAvailabilityCount === 0)
        }
        backdisabled={step === 3 ? isLoading : false}
        width={
          step !== 3
            ? "560px"
            : showManualCalibration
            ? getWidthPercentage() : fovIdsCount > 2 ? "1180px"
            : "808px" 
        }
        // surface={showManualCalibration ? "dark" : "light"}
        buttonWidth={showManualCalibration ? "80%" : ""}
        id={showManualCalibration ? "manualCamera" : ""}
        hideButtons={showExampleModal ? true : false}
        showModalTitle={showManualCalibration ? true : false}
        disableOutsideClick={true}
        closeButtonClass="manual_calibration_close-btn"
      >
        <br />
        <Loader
          active={showCalibrationLoader}
          fullscreen={false}
          surface="light"
        />
        {step === 3 ? (
          <>
            <StreamCalibrationModal
              showExampleModal={showExampleModal}
              setShowExampleModal={setShowExampleModal}
              handleOnBack={handleOnBack}
              fovDatas={fovDatas}
              companionDevice={companionData?.id ? companionData : companionDevice}
              handleNextCalibrationSteps={handleNextCalibrationSteps}
              onNextDisableChange={handleNextDisableChange}
              setHandleNextCalibrationSteps={setHandleNextCalibrationSteps}
              onClose={handleClose}
              showManualCalibration={showManualCalibration}
              setShowManualCalibration={setShowManualCalibration}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              manualCount={manualCount}
              setmanualCount={setmanualCount}
              manualDevices={manualDevices}
              setManualDevices={setManualDevices}
              showManualBack={showManualBack}
              setShowManualBack={setShowManualBack}
              setFovIdsCount={setFovIdsCount}
              onCalibrationComplete={handleCalibrationComplete}
              initialEnableSearch={fovDatas}
              isHistoricalSearchEligible={isHistoricalSearchEligible}
            />
          </>
        ) : !step && modalOpenObj?.onBoradType !== "Auto" ? (
          <div
          >
            <div>
              <CameraInfoForm onNextDisableChange={handleNextDisableChange} />
            </div>
            <div>
              <StreamInfoForm
                rtspUrl={rtspUrl}
                onNextDisableChange={handleNextDisableChange}
                srollchange={srollchange}
                onClose={handleClose}
              />
            </div>
          </div>
        ) : step === 1 ? (
          <>
            {modalOpenObj?.onBoradType === "Manual" ? (
              <>
                <SnapshotSection
                  editFlow={modalOpenObj?.editFlow ? true : false}
                  fovData={fovDatas}
                  companionData={companionData}
                  selectCameraQr={selectCameraQr}
                  onBoradType={modalOpenObj?.onBoradType}
                />
                <LocationSelection
                  editFlow={
                    modalOpenObj?.editFlow ? modalOpenObj?.editFlow : false
                  }
                  onImageDownloadFailed={handleImageDownloadFailure}
                  onPositionChange={(newPosition) => {
                    camPositionRef.current = newPosition;
                  }}
                  onNextDisableChange={handleNextDisableChange}
                  camDetails={modalOpenObj?.camDetails}
                  onBoradType={modalOpenObj?.onBoradType}
                />
              </>
            ) : (
              <>
                <SnapshotSection
                  editFlow={modalOpenObj?.editFlow}
                  onBoradType={modalOpenObj?.onBoradType}
                />
                <CompanionSelection
                  editFlow={modalOpenObj?.editFlow}
                  isPairing={modalOpenObj?.isPairing}
                  onNextDisableChange={handleNextDisableChange}
                  onBoradType={modalOpenObj?.onBoradType}
                />
              </>
            )}
            {modalOpenObj?.onBoradType !== "Manual" && (
              <LocationSelection
                editFlow={
                  modalOpenObj?.editFlow ? modalOpenObj?.editFlow : false
                }
                onImageDownloadFailed={handleImageDownloadFailure}
                onPositionChange={(newPosition) => {
                  camPositionRef.current = newPosition;
                }}
                onNextDisableChange={handleNextDisableChange}
                camDetails={modalOpenObj?.camDetails}
                onBoradType={modalOpenObj?.onBoradType}
              />
            )}
          </>
        ) : (
          <NameInfoForm
            editFlow={modalOpenObj?.editFlow}
            onNextDisableChange={handleNextDisableChange}
            onBoradType={modalOpenObj?.onBoradType}
          />
        )}
        <Loader active={isLoading} fullscreen={false} surface="light" />
        <div ref={formRef} />
        {showExampleModal && (
          <div style={{ cursor: "pointer" }}>
            <Icon name="left-caret" size="medium" />
            <span onClick={() => handleOnBack()}> Back </span>
          </div>
        )}
      </BaseModal>
    </>
  );
};

export default DiscoverCamera;
